var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "已报名学生列表",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "popover", staticStyle: { "flex-direction": "column" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "学生姓名", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "age", label: "年龄", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "sex", label: "性别", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.sex == 1 ? _c("span", [_vm._v("男")]) : _vm._e(),
                        row.sex == 2 ? _c("span", [_vm._v("女")]) : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "avatar", label: "学生头像", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("el-image", {
                          staticStyle: { width: "60px", height: "60px" },
                          attrs: { src: row.avatar, fit: "cover" }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "performance_rating", label: "评分" }
              }),
              _c("el-table-column", {
                attrs: { prop: "checkin_status_text", label: "签到状态" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "80",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.checkin_status == 1
                          ? _c("div", { staticClass: "x-c" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.studentScore.init(
                                        scope.row.id
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" 评分 ")]
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.tableData.length
            ? _c("el-pagination", {
                attrs: {
                  layout: "total, prev, pager, next",
                  "current-page": _vm.paramsData.page,
                  total: _vm.total,
                  "page-size": 10
                },
                on: { "current-change": _vm.getStudentListFn }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      ),
      _c("studentScore", {
        ref: "studentScore",
        on: {
          change: function($event) {
            return _vm.getStudentListFn(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }